import { SubmissionWithTypedPayload } from '../types';

export function getProfileFullName(candidate: SubmissionWithTypedPayload) {
  return [candidate.profile?.firstName, candidate.profile?.lastName]
    .filter(Boolean)
    .join(' ');
}

export function getProfileLocation(candidate: SubmissionWithTypedPayload) {
  return [candidate.profile?.address?.city, candidate.profile?.address?.country]
    .filter(Boolean)
    .join(', ');
}

export function getLegacyCandidateDisplay(
  candidate: SubmissionWithTypedPayload,
) {
  return {
    subtitle: getProfileLocation(candidate),
    title: getProfileFullName(candidate) || 'Unnamed candidate',
  };
}

export function getCandidateDisplayWithCitySubtitle(
  candidate: SubmissionWithTypedPayload,
) {
  return {
    subtitle: candidate.profile?.address?.city,
    title: getProfileFullName(candidate) || 'Unnamed candidate',
  };
}
